<template>
  <div class="add-goods">
    <div class="setting">
      <div class="setting-form-wrap">
        <el-form class="setting-form" ref="addbasic-form" :model="addbasic" :rules="rules">
          <div class="form-wrap">
            <div class="setting-form-tit">
              基本信息
            </div>
            <div class="form-body">
              <el-form-item label="商品名称:" prop="name">
                <el-input v-model="addbasic.name" placeholder="请输入商品名称"></el-input>
              </el-form-item>
              <el-form-item label="简单描述:" prop="des">
                <el-input v-model="addbasic.des" placeholder="请输入商品描述"></el-input>
              </el-form-item>
              <el-form-item class="logo-item" label="商品缩略图:" prop='imgLogo'>
                <div v-if="addbasic.imgLogo" style="display:inline-block">
                  <img :src="addbasic.imgLogo" alt="">
                </div>
                <div v-else style="display:inline-block">
                  <img :src="addbasic.defaultImg" alt="">
                </div>
                <el-upload :show-file-list="false" action="/" accept="image/jpeg,image/png" class="el-upload-button" :on-change="handleLogoUpload" :before-upload="beforeLogoUpload">
                  <el-button type="primary">上传</el-button>
                </el-upload>
                <div class="form-item-des">（尺寸宽高比为1:1）</div>
              </el-form-item>
              <el-form-item class="gallery-item" label="商品图库:" prop="imgArr">
                <div class="item-con-banner">
                  <div v-if="showgalleryDefault" style="display:inline-block">
                    <div class="item-banner" v-for="(item, index) in addbasic.imgArr" :key="index">
                      <img :src="item" alt="">
                      <i class="el-icon-close" @click="bannerClose(index)"></i>
                    </div>
                  </div>
                  <div class="item-banner" v-else style="display:inline-block;margin-right:0">
                    <img :src="addbasic.defaultImg" alt="">
                  </div>
                  <el-upload :show-file-list="false" action="/" accept="image/jpeg,image/png" class="el-upload-button" multiple :on-change="handleGalleryUpload" :before-upload="beforeGalleryUpload" v-show="showUploadGalleyBtn">
                    <el-button type="primary">上传</el-button>
                  </el-upload>
                </div>
                <div class="form-item-des">（尺寸宽高比为1:1，最多上传5张）</div>
              </el-form-item>
              <el-form-item label="服务区域:" prop="service_area">
                <el-select
                  v-model="addbasic.service_area"
                  multiple
                  placeholder="请选择服务区域"
                >
                  <el-option-group
                    v-for="group in serviceAreas"
                    :key="group.label_id"
                    :label="group.label"
                  >
                    <el-option
                      v-for="(label, key) in group.options"
                      :key="key"
                      :label="label"
                      :value="parseInt(key)"
                    ></el-option>
                  </el-option-group>
                </el-select>
              </el-form-item>
              <el-form-item class="more-desc" label="详细描述:" prop="product_desc">
                <div class="item-con-seller-des">
                  <wangeditor :catchData="catchData" :content="addbasic.product_desc" :rangenum="rangenum"></wangeditor>
                </div>
              </el-form-item>
            </div>
          </div>
          <div class="form-wrap">
            <div class="setting-form-tit">
              商品属性（有sku属性时，实际库存和价格以sku为准）
            </div>
            <div class="form-body">
              <el-form-item label="所属类别:" prop="category_id">
                <el-select v-model="addbasic.category_id" filterable placeholder="请选择商品类别">
                  <el-option v-for="item of category_arr" :key="item.category_id" :label="item.category_name" :value="item.category_id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="数量设置:" prop="kc_num">
                <el-row class="setting-num">
                  库存数量
                  <el-input-number class="num-counter" v-model="addbasic.kc_num" @change="handleChange" :min="0" :max="10000" label="描述文字"></el-input-number>
                </el-row>
                <el-row class="counter-num setting-num">
                  限制购买
                  <el-input-number class="num-counter" v-model="addbasic.xz_num" @change="handleChange" :min="0" :max="10000" label="描述文字"></el-input-number>
                </el-row>
                <el-row class="counter-num setting-num">
                  单笔限制
                  <el-input-number class="num-counter" v-model="addbasic.dbxz_num" @change="handleChange" :min="0" :max="10000" label="描述文字"></el-input-number>
                </el-row>
              </el-form-item>
              <el-form-item label="市场价格:" prop="sPrice">
                <el-input v-model="addbasic.sPrice" oninput="value=value.replace(/[^\d.]/g,'')" placeholder="请输入价格" class="price-input" v-on:blur='dealmoney("sPrice")'>
                  <template slot="prepend">￥</template>
                </el-input>
              </el-form-item>
              <el-form-item label="销售价格:" prop="xPrice">
                <el-input v-model="addbasic.xPrice" oninput="value=value.replace(/[^\d.]/g,'')" placeholder="请输入价格" class="price-input" v-on:blur='dealmoney("xPrice")'>
                  <template slot="prepend">￥</template>
                </el-input>
                <div class="form-item-des">如果设置SKU,则自动获取SKU最低价格</div>
              </el-form-item>
            </div>
          </div>

          <div class="form-wrap sku-from-wrap">
            <div class="setting-form-tit">
              库存(SKU)
            </div>
            <div v-show="showTable">
              <el-table :data="skuArr" style="width: 100%" max-height="250" class="sku-table">
                <el-table-column prop="thumb" label="缩略图" width="120" class='sku-thumb' align="center">
                  <template slot-scope="scope">
                    <img :src="scope.row.thumb">
                  </template>
                </el-table-column>
                <el-table-column prop="sku_attr" label="分类方式" width="160" align="center">
                </el-table-column>
                <el-table-column prop="sku_val" label="商品属性" align="center">
                </el-table-column>
                <el-table-column prop="price" label="销售价格" width="300" align="center">
                </el-table-column>
                <el-table-column prop="product_number" label="库存数量" width="200" align="center">
                </el-table-column>
                <el-table-column label="操作" align="center">
                  <template slot-scope="scope">
                    <el-button @click.native.prevent="editeRow(scope.$index, skuArr)" type="text" size="small">
                      编辑
                    </el-button>
                    <el-button @click.native.prevent="deleteRow(scope.$index, skuArr)" type="text" size="small">
                      移除
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>

            <div class="form-body">
              <el-form-item class="sku-add">
                <el-button type="primary" @click="addSku">添加</el-button>
              </el-form-item>
            </div>
          </div>

          <div class="form-wrap skill-wrap">
            <el-form-item label="立即上架:">
              <el-switch v-model="addbasic.is_sj" active-color="#2E71FE" inactive-color="#F6F8FB"></el-switch><span class="switch-text">{{addbasic.is_sj==1?"开":"关"}}</span>
            </el-form-item>
          </div>

          <div>
            <el-form-item label="">
              <el-button class="form-btn form-btn-wraning" type="wraning" @click='pushProduct' :loading="submitting" :disabled="submitting">
                {{ submitting ? '发布中...' : '发布' }}
              </el-button>
              <!-- <el-button class="form-btn" type="default">暂存</el-button> -->
            </el-form-item>
          </div>

        </el-form>

      </div>
    </div>

    <popAddSku :dialogVisible.sync="showskudialog" :title="'添加库存'+'(SKU)'" @hideDg="dialogHide" @commitSku='handleSkuData'></popAddSku>
    <popEditSku :dialogVisible.sync="showsEditsku" :editdata='editdata' :editindex='editindex' :title="'编辑库存'+'(SKU)'" @hideDg="EditdialogHide" @handleEdit='handleEdit'></popEditSku>
  </div>
</template>

<script>
import wangeditor from '@/components/wangeditor'
import popAddSku from "@/components/popover/popAddSku.vue";
import popEditSku from '@/components/popover/popEditSku.vue'
import { debounce } from '@/utils/debounce.js'

export default {
  name: "FuncFormsEdit",
  components: {
    popAddSku, popEditSku, wangeditor
  },
  data () {
    return {
      content: null,
      rangenum:null,
      editorOption: {
        placeholder: '请输入详细商品描述'
      },
      addbasic: {
        name: "",
        des: "",
        product_desc: "",
        defaultImg: "./static/img/defaultimg.png",
        imgLogo: "",
        phone: "0769-66666666",
        imgArr: [],
        imgs: [],
        category_id: "",
        sPrice: "",
        xPrice: "",
        // msPrice:"",
        kc_num: 0,
        xz_num: 0,
        dbxz_num: 0,
        service_area: [],
      },
      dj: 0,
      sj: 0,
      editdata: {

      },
      rules: {
        name: [
          { required: true, message: '请输入商品名称', trigger: 'blur' },
        ],
        des: [
          { required: true, message: '请填写描述', trigger: 'blur' }
        ],
        imgLogo: [
          { required: true, message: '请选择缩略图', trigger: 'change' }
        ],
        // mstime: [
        //   { required: true, message: '请选择时间', trigger: 'change' }
        // ],
        // msPrice:[
        // 	{ required: true, message: '请填写秒杀价格', trigger: 'blur' }
        // ],
        imgArr: [
          { type: 'array', required: true, message: '请至少选择一张图', trigger: 'change' }
        ],
        product_desc: [
          { required: true, message: '请填写商品详情', trigger: 'blur' }
        ],
        category_id: [
          { required: true, message: '请选择商品类别', trigger: 'change' }
        ],
        kc_num: [
          { required: true, message: '请填写库存数', trigger: 'change' }
        ],
        xz_num: [
          { required: true, message: '请填写限制购买量', trigger: 'change' }
        ],
        dbxz_num: [
          { required: true, message: '请填写单笔限制购买量', trigger: 'change' }
        ],
        sPrice: [
          { required: true, message: '请输入市场价格', trigger: 'blur' }
        ],
        xPrice: [
          { required: true, message: '请输入销售价格', trigger: 'blur' }
        ],
        service_area: [
          { required: true, message: '请选择服务区域', trigger: 'change' }
        ]
      },
      category_arr: [],
      serviceAreas: [],
      showskudialog: false,
      showsEditsku: false,
      skuArr: [],
      editindex: '',//要编辑的那行的index
      // 提交状态标志
      submitting: false
    };
  },
  methods: {
    getProductCategory () {
      this.$store.dispatch("setTableLoading", true);
      this.$axios
        .get("/api/v1/category")
        .then(res => {
          if (res.data.status == "200") {
            let categorys = res.data;
            this.category_arr = categorys.data;
            //更新子组件
            this.updataChild = new Date().getTime();
            this.$store.dispatch("setTableLoading", false);
          } else {
            this.$popup(res.data.msg, "error");
          }
        })
        .catch(error => {

        });
    },
    fetchServiceAreas() {
      this.$axios.get('/api/v1/coupons_area')
        .then(response => {
          if (response.data.status === 200) {
            this.serviceAreas = response.data.data;
          }
        })
        .catch(error => {
          console.error('获取服务区域数据失败:', error);
          this.$message.error('获取服务区域数据失败');
        });
    },
    handleLogoUpload (file, fileList) {
      this.addbasic.imgLogo = URL.createObjectURL(file.raw);
      this.formData.append('product_thumb', file.raw);
      return false;
    },
    handleGalleryUpload (file, fileList) {
      if (!this.showUploadGalleyBtn) {
        this.$popup('最多上传5张', 'error');
        return false;
      }
      this.addbasic.imgArr.push(URL.createObjectURL(file.raw));
      this.addbasic.imgs.push(file);
      return false;
    },
    beforeLogoUpload (file) {
      // 在 handleLogoUpload 中处理文件
      return false;
    },
    beforeGalleryUpload (file) {
      // 在 handleGalleryUpload 中处理文件
      return false;
    },
    bannerClose (index) {
      this.addbasic.imgArr.splice(index, 1);
      this.addbasic.imgs.splice(index, 1);
    },
    //新增库存
    addSku () {
      this.showskudialog = !this.showskudialog;
    },
    dialogHide () {
      this.showskudialog = !this.showskudialog;
    },
    EditdialogHide () {
      this.showsEditsku = !this.showsEditsku;
    },
    handleChange () { },
    handleSkuData (res) {
      this.skuArr.push(res);
    },
    pushProduct: debounce(function () {
      // 防止重复提交
      if (this.submitting) {
        return;
      }

      this.submitting = true;

      this.$refs["addbasic-form"].validate(valid => {
        if (valid) {
          // 创建新的FormData实例用于提交
          const submitFormData = new FormData();

          // 添加SKU数据
          var data = [];
          for (var i = 0, len = this.skuArr.length; i < len; i++) {
            data.push(this.skuArr[i]);
          };
          if (data.length > 0) {
            for (let i = 0; i < data.length; i++) {
              submitFormData.append('sku[' + i + '][sku_attr]', data[i].sku_attr);
              submitFormData.append('sku[' + i + '][sku_val]', data[i].sku_val);
              submitFormData.append('sku[' + i + '][_remove_]', data[i]._remove_);
              submitFormData.append('sku[' + i + '][sku_thumb]', data[i].skuThumb);
              submitFormData.append('sku[' + i + '][product_number]', data[i].product_number);
              submitFormData.append('sku[' + i + '][price]', data[i].price);
            }
          }

          // 添加基础字段到formData
          submitFormData.append('product_name', this.addbasic.name);
          submitFormData.append('product_category_id', this.addbasic.category_id);
          submitFormData.append('product_number', this.addbasic.kc_num);
          submitFormData.append('product_brief', this.addbasic.des);
          submitFormData.append('product_desc', this.addbasic.product_desc.replace(this.$goodsImgReg, ''));
          submitFormData.append('limit_quantity', this.addbasic.xz_num);
          submitFormData.append('once_limit_quantity', this.addbasic.dbxz_num);
          submitFormData.append('market_price', this.addbasic.sPrice);
          submitFormData.append('shop_price', this.addbasic.xPrice);

          this.sj = this.addbasic.is_sj == true ? 1 : 0;
          submitFormData.append('is_on_sale', this.sj);

          // 添加服务区域
          if (this.addbasic.service_area && this.addbasic.service_area.length > 0) {
            for (let i = 0; i < this.addbasic.service_area.length; i++) {
              submitFormData.append('service_area[]', this.addbasic.service_area[i]);
            }
          }

          // 添加缩略图文件
          if (this.formData.has('product_thumb')) {
            submitFormData.append('product_thumb', this.formData.get('product_thumb'));
          }

          // 添加图库文件
          if (this.addbasic.imgs && this.addbasic.imgs.length > 0) {
            for (let i = 0; i < this.addbasic.imgs.length; i++) {
              submitFormData.append('photo_ids[]', this.addbasic.imgs[i].raw);
            }
          }

          this.$axios({
            method: 'post',
            url: '/api/v1/products',
            data: submitFormData,
            headers: { 'Content-Type': 'multipart/form-data' }
          })
            .then(res => {
              if (res.data.status == "200") {
                this.$store.dispatch("setCommitFlag", false);
                this.$popup('新增商品成功', 'success');

                // 清空表单数据
                this.resetForm('addbasic-form');
                this.skuArr = [];
                this.addbasic.kc_num = 0;
                this.addbasic.xz_num = 0;
                this.addbasic.dbxz_num = 0;
                this.addbasic.imgs = [];
                this.addbasic.imgLogo = "";
                this.addbasic.imgArr = [];
                this.formData = new FormData(); // 重新初始化formData

                // 间隔1秒 跳转到前一页
                setTimeout(() => {
                  // 关闭当前页
                  this.$store.dispatch("removeHeadTabo", this.$store.state.currentHeadTab);
                  // 跳回列表页
                  this.$store.dispatch("addHeadTab", {
                    addTitle: "商品列表",
                    addUrl: "goods-list"
                  });
                  // 触发列表页刷新
                  this.$store.dispatch("setUpdataList", true);

                }, 1000);
              }
              this.submitting = false;
            })
            .catch(error => {
              this.submitting = false; // 重置状态，允许重新提交
              this.$popup('发布失败，请重试', 'error');
            })
        } else {
          this.submitting = false;
          this.$popup('信息填写不正确', 'error');
          return false;
        }
      });
    }, 300),
    //移除某行sku
    deleteRow (index, rows) {
      this.$confirm("确定删除吗?", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        rows.splice(index, 1);
      })
    },
    editeRow (index, rows) {
      this.editdata = deepCopy(rows[index]);
      this.editindex = index;
      this.showsEditsku = !this.showsEditsku;
    },
    //修改skudata
    handleEdit (data, index) {
      this.skuArr.splice(index, 1, data);
    },
    dealmoney (param) {
      this.addbasic[param] = new Number(this.addbasic[param]).toFixed(2);
    },
    // 重置表单
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    catchData (value) {
       let currentRange = window.getSelection().getRangeAt(0);
       this.rangenum = currentRange;
       this.content = value      //在这里接受子组件传过来的参数，赋值给data里的参数
       // 把富文本子组件的内容赋值到父组件
      this.addbasic.product_desc = this.content;
    }
  },
  computed: {
    showgalleryDefault () {
      return this.addbasic.imgArr.length > 0 ? true : false;
    },
    showUploadGalleyBtn () {
      return this.addbasic.imgArr.length >= 5 ? false : true;
    },
    showTable () {
      return this.skuArr.length > 0 ? true : false;
    }

  },
  created () {
    this.$store.dispatch("setCommitFlag", true);
    this.getProductCategory();
    this.fetchServiceAreas();
    // 初始化formData用于存储文件
    this.formData = new FormData();
  },
  mounted () {
    // 已在created中调用getProductCategory()，避免重复请求
  }
};

//对象深拷贝，防止传给子组件数据改变直接影响父组件
var deepCopy = function (source) {
  var result = {};
  for (var key in source) {
    if (typeof source[key] === 'object') {
      result[key] = deepCopy(source[key])
    } else {
      result[key] = source[key]
    }
  }
  return result;
}
</script>

<style lang="less">
.add-goods {
  .el-form-item__error {
    left: 100px;
  }
  .setting-form-wrap {
    padding: 0px;
    margin-bottom: 20px;
    color: #081234;
    font-family: MicrosoftYaHei;
    background-color: #f6f8fb;
    .setting-form-tit {
      height: 15px;
      padding-left: 10px;
      margin-bottom: 16px;
      line-height: 15px;
      text-align: left;
      font-size: 16px;
      font-weight: bold;
      border-left: 5px solid #2e71fe;
    }
    .form-wrap {
      margin-bottom: 20px;
      padding-top: 16px;
      padding-left: 20px;
      background-color: #ffffff;
      &.skill-wrap {
        padding-top: 0;
        .el-form-item__label {
          font-weight: normal;
          color: #0a1235;
        }
      }
      .form-body {
        padding: 30px 60px;
        border-top: 1px solid #f6f8fb;
      }
    }
    .setting-form {
      .el-form-item {
        margin-bottom: 20px;
      }
      .logo-item {
        .el-form-item__label {
          line-height: 14px;
          padding: 0 12px 0 0;
        }
        img {
          width: 120px;
          height: 120px;
        }
        .el-upload-button {
          display: inline-block;
          vertical-align: bottom;
          line-height: normal !important;
        }
      }
      .gallery-item {
        .el-form-item__label {
          line-height: 14px;
        }
        .el-upload-button {
          display: inline-block;
          vertical-align: bottom;
          line-height: normal !important;
        }
        .form-item-desc {
          margin-left: 16px;
        }
      }
      .more-desc {
        .el-form-item__label {
          line-height: 14px;
        }
      }
      .el-form-item__label {
        padding: 0 26px 0 0;
        color: #081234;
        // font-weight: bold;
      }
      .el-form-item__content {
        padding-left: 80px;
        text-align: left;
        color: #8d8f96;
        .form-btn {
          width: 76px;
          height: 37px;
          border-radius: 19px;
          text-align: center;
          line-height: 37px;
          color: #2e71fe;
          border: 1px solid #2e71fe;
          background-color: #ffffff;
          &.form-btn-wraning {
            color: #ffffff;
            background-color: #ff6529;
            border-color: #ff6529;
          }
        }
        .switch-text {
          display: inline-block;
          margin-left: 6px;
          line-height: 40px;
          font-size: 12px;
        }
        .form-item-des {
          font-size: 12px;
          color: #ff6529;
          margin-left: 12px;
        }
        .item-con-seller-des {
          width: 900px;
          height: 580px;
          margin-left: 8px;
        }
        .item-con-banner {
          // width: 510px;
          .item-banner {
            position: relative;
            display: inline-block;
            vertical-align: bottom;
            width: 120px;
            height: 120px;
            margin-right: 20px;
            margin-bottom: 0;
            img {
              width: 120px;
              max-width: 120px;
              height: 120px;
            }
            i {
              position: absolute;
              display: block;
              padding: 5px;
              top: 0;
              right: 0;
              color: #ffffff;
              background-color: rgba(0, 0, 0, 0.3);
            }
          }
          .item-banner:last-child {
            margin-right: 0;
          }
        }
        img {
          vertical-align: middle;
        }
        .setting-num {
          color: #081234;
        }
        .counter-num {
          padding: 0 0 0 14px;
        }
        .el-input-number {
          position: relative;
          vertical-align: middle;
          width: 100px;
          height: 28px;
          padding: 4px;
          box-sizing: border-box;
          background-color: #f6f8fb;
          .el-input-number__decrease,
          .el-input-number__increase {
            top: 4px;
            width: 20px;
            height: 20px;
            line-height: 20px;
            background-color: #2e71fe;
            color: #ffffff;
          }
          .el-input-number__decrease {
            left: 4px;
          }
          .el-input-number__increase {
            right: 4px;
          }
          .el-input {
            width: 92px;
            height: 20px;
          }
          .el-input__inner {
            height: 20px !important;
            padding: 0 !important;
          }
        }
        .el-input {
          width: 300px;
          .el-input__inner {
            display: inline-block;
            vertical-align: top;
            height: 45px;
            line-height: 45px;
            font-size: 14px;
            color: #081234;
            background-color: #f6f8fb;
            border: none;
            border-radius: 0;
          }
          .el-input-group__prepend {
            border: none;
          }
        }
        .price-input {
          .el-input__inner {
            padding: 0;
          }
          .el-input-group__prepend {
            width: 5px;
            padding: 10px;
          }
        }
        .el-button {
          padding: 0;
          border: none;
          margin-left: 16px;
        }
        .el-button--defaul {
          width: 76px;
          height: 37px;
          color: #8d8f96;
          background-color: #f6f8fb;
          border-radius: 19px;
        }
        .el-button--primary {
          width: 56px;
          height: 29px;
          font-size: 12px;
          background-color: #2e71fe;
          border-radius: 19px;
          border: none;
        }
        .el-button--primary:focus,
        .el-button--primary:hover {
          color: #fff;
        }
      }
      .sku-from-wrap {
        padding: 16px 0 0 0;
        .setting-form-tit {
          margin-left: 20px;
        }
        .form-body {
          padding: 0;
          .sku-add {
            padding: 20px 0;
            .el-form-item__content {
              width: 100%;
              height: 100%;
              padding: 0;
              text-align: center;
            }
            .el-button {
              margin: 0;
            }
          }
        }
        .sku-table {
          img {
            width: 32px;
            height: 32px;
          }
        }
      }
    }
    &.info-form {
      height: 421px;
      .el-form-item {
        margin-bottom: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/add-goods.vue